module.exports = __webpack_public_path__ + "img/2.5D-C-区域技术市场.8dac88e7.png";